import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['focus']

  focus() {
    this.focusTarget.focus();
  }
}
